import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'total_num_of_wrkrs_in_third_wage_level_defined_by_fac'

export const dataPointDefinition = {
  retracedId: 'total_num_of_wrkrs_in_third_wage_level_defined_by_fac',
  name: 'TOTAL number of workers in third wage level defined by facility',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wage-27',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7920,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
